import { action } from 'typesafe-actions';
import { ActionType, REGIONS } from './countries.types';
import { MatchingService } from '../../../services/MatchingService';
import { ToastService } from '../../../services/ToastService';

export const getCountries = () => {
  return async (dispatch) => {
    try {
      const countries = await MatchingService.get('countries');
      dispatch(action(ActionType.GET_COUNTRIES, countries));
    } catch (e) {
      ToastService.error('Error Occurred Fetching Countries', e);
    }
  };
};

export const loadTimezone = () => {
  return async (dispatch) => {
    try {
      const { results } = await MatchingService.get(`timezones-public`);
      dispatch(action(ActionType.TIMEZONE_LIST, { results }));
    } catch (e) {
      ToastService.error('Error Occurred loading country timezone', e);
    }
  };
};

export const getEasternEuropeCountries = () => {
  return async (dispatch) => {
    try {
      const countries = await MatchingService.get(`countries/region/${REGIONS.EASTERN_EUROPE}`);
      dispatch(action(ActionType.GET_EASTERN_EUROPE_COUNTRIES, countries));
    } catch (e) {
      ToastService.error('Error Occurred Fetching EE Countries', e);
    }
  };
};
